webpackJsonp([34230457893583],{

/***/ 667:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Models = __webpack_require__(18);
	
	var _Models2 = _interopRequireDefault(_Models);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Models2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'parse'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'parse()'
	      ),
	      ' method provides a way to transform data provided to the model before it\'s saved as the model\'s ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'attributes'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Default Implementation'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The default implementation looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      parse: function(response) {\n        return response;\n      },\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Usage'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Let\'s say you have an API endpoint located at ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'http://localhost:1337/tweets/1'
	      ),
	      ', that returns a tweet that looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      {\n        id: 1,\n        text: \'An old tweet\'\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you wanted to retrieve that tweet, you could create this model:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      import { Model } from \'lore-models\';\n\n      const Tweet = Model.extend({\n        urlRoot: \'http://localhost:1337/tweets\'\n      });\n\n      const tweet = new Tweet({\n        id: 1\n      });\n\n      tweet.fetch();\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Once the API call returns, ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweet.attributes'
	      ),
	      ' would look like this (exactly mirroring the API response):'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      {\n        id: 1,\n        text: \'An old tweet\'\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Sometimes you might want to transform that data though, such as changing the name or value of a property, or adding a new field, which can be a quick way to resolve breaking API changes.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You can do that by defining a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'parse()'
	      ),
	      ' like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      import { Model } from \'lore-models\';\n\n      const Tweet = Model.extend({\n        urlRoot: \'http://localhost:1337/tweets\',\n\n        parse: function(response){\n          response.message = response.text;\n          return response;\n        }\n      });\n\n      const tweet = new Tweet({\n        id: 1\n      });\n\n      tweet.fetch();\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Whatever the API returns will be passed to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'parse()'
	      ),
	      ' as ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'response'
	      ),
	      ', and whatever that function returns will be saved as the model\'s ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'attributes'
	      ),
	      '. In the code above, we\'re copying the value of ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'text'
	      ),
	      ' onto a new attribute called ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'message'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This time, once the API call returns, ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweet.attributes'
	      ),
	      ' will look like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      {\n        id: 1,\n        text: \'An old tweet\',\n        message: \'An old tweet\'\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'That\'s the normal use for ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'parse()'
	      ),
	      ' - transforming data returned from an API endpoint. But sometimes it\'s useful to create a model and parse the data provided to it. By default this does not happen.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'For example, take a look at the code below:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      import { Model } from \'lore-models\';\n\n      const Tweet = Model.extend({\n        urlRoot: \'http://localhost:1337/tweets\',\n\n        parse: function(response){\n          response.message = response.text;\n          return response;\n        }\n      });\n\n      const tweet = new Tweet({\n        id: 1,\n        text: \'An old tweet\'\n      });\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If we were to examine ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweet.attributes'
	      ),
	      ' at this point, they would look like this, mirroring the data we provided to the constructor:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      {\n        id: 1,\n        text: \'An old tweet\'\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If we wanted the model to parse that data, we need to tell it to by providing an options object, like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      const tweet = new Tweet({\n        id: 1,\n        text: \'An old tweet\'\n      }, {\n        parse: true\n      });\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Here we\'ve provided an ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'options'
	      ),
	      ' object as a second argument to the constructor, and set ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'parse'
	      ),
	      ' to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'true'
	      ),
	      '. This time ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweet.attributes'
	      ),
	      ' will look like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      {\n        id: 1,\n        text: \'An old tweet\',\n        message: \'An old tweet\'\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Now the data will mirror what we would have gotten by calling the API endpoint.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-models-properties-parse-js-54798644066b4d9ed0f0.js